// extracted by mini-css-extract-plugin
export default {"container":"lp-z","brandName":"mp-z","productName":"np-z","productNamePdpEnhancements":"op-z","breakLongProductName":"pp-z"};